/* eslint no-useless-escape: 0 */

export const openingTagRegexp = (tag: string) => new RegExp(`<${tag} .*?[^\/]>|<${tag}>`, 'gm');

export const closingTagRegexp = (tag: string) => new RegExp(`<\/${tag}>`, 'gm');

export const autoClosingTagRegexp = (tag: string) => new RegExp(`<${tag} .*?\/>|<${tag}\/>`, 'gm');

export const htmlTag = /<[^>]*>/g;
